import { combineReducers } from 'redux';

import isOpen from './isOpen';

export const reducer = combineReducers({
  isOpen
});
